module.exports = __webpack_public_path__ + "static/media/proyectos.22b7f6c6.svg";